import { Component, Prop, Vue } from "vue-property-decorator";
import { Icon } from "ant-design-vue";
import { Table, Column, Select } from "ant-design-vue/lib";
import draggable from "vuedraggable";
import { fmtMsg } from "commonui";
import { ILessonPlanItemModel, LessonPlanItemPropsName, LessonPlanItemType } from "@/models/master-plan";
import { LessonPlanLocale } from "@/locales/localeid";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";
import { Activity } from "@/util/enum";

@Component({
	components: {
		"a-icon": Icon,
		"a-table": Table,
		"a-select": Select,
		"a-select-option": Select.Option,
		draggable
	}
})
export default class TransitionList extends Vue {
	@Prop({ default: [] }) list!: ILessonPlanItemModel[];
	@Prop({ default: false }) isDisabled?: boolean;
	private columns: Column[] = [
		{
			title: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageTransitionListColumnPositionTitle),
			width: "20%",
			dataIndex: LessonPlanItemPropsName.position,
			key: LessonPlanItemPropsName.position
		},
		{
			title: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageTransitionListColumnItemTitle),
			width: "70%",
			dataIndex: LessonPlanItemPropsName.item,
			key: LessonPlanItemPropsName.item
		},
		// {
		// 	title: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageTransitionListColumnPositionTitle),
		// 	width: "30%",
		// 	dataIndex: LessonPlanItemPropsName.position,
		// 	key: LessonPlanItemPropsName.position,
		// 	scopedSlots: { customRender: "lessonSequence" },
		// },
		{
			title: "",
			width: "10%"
		}
	];

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	get rowKey(): string {
		return LessonPlanItemPropsName.position;
	}

	get trasitions(): ILessonPlanItemModel[] {
		return this.list;
	}

	set trasitions(value) {
		this.$emit("lessonSequencesChanged", value);
	}

	get lessonPlanItemType(): any {
		return LessonPlanItemType;
	}

	get activityType(): any {
		return Activity;
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	//
	// 	onLessonSequenceChanged(transition, newLessonSequence) {
	// 		this.$emit("swapLessonSequence", { transition, newLessonSequence });
	// 	}

	onRemoveTransition(transition) {
		if (!this.isDisabled) {
			this.$emit("removeTransition", transition);
		}
	}
}
